import React from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => {

  const navlink = document.querySelectorAll('.nav-link')
  const navbarBody = document.querySelector('.navbar-collapse');
 
 
  navlink.forEach(element => {
   element.addEventListener('click' , () => {
    navbarBody.classList.remove('show')
   })
  })

  return (
    <nav className="navbar navbar-expand-lg py-4 shadow-sm  ">
      <div className="container d-flex align-item-center">
        <NavLink className="navbar-brand order-0" to="/" >
          <img src="image/logo-light.png" className="img-fluid" alt="website logo" />
        </NavLink>
        <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        <div
          className="collapse navbar-collapse order-2"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0" >
            <li className="nav-item">
              <NavLink className="nav-link active" aria-current="page" to="/">
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link " aria-current="page" to="/about">
                about us
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                className="nav-link "
                aria-current="page"
                to="/converter"
              >
                converter
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link " aria-current="page" to="/blog">
                blog
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link " aria-current="page" to="/contact">
                contact us
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="nav-btn order-lg-3 order-4 d-lg-block d-none "  >
          <NavLink to="/contact" className="ms-4 btn btn-primary">
            get the app 
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
